import "./ScreenLocker.scss";
import React from "react";
import { useSelector } from "react-redux";
import { screenLockerSelector } from "./screenLockerDomain";
import { LoadingSpinnerComponent } from "../../../../npsSurveys/_shared/stateComponents/LoadingSpinnerComponent";

export function ScreenLockerComponent() {
    const screenLockerState = useSelector(screenLockerSelector);
    return !screenLockerState?.lockedOn ? null : (
        <div className="ScreenLockerComponent">
            <LoadingSpinnerComponent isLoading={true} />
        </div>
    );
}
